class BISModal extends window.BAO.CustomElement({
  SuperClass: HTMLDialogElement,
}) {
  static observedAttributes = ['variant-id', 'product-title']

  constructor () {
    super()

    this.variantId = null
    this.productName = null
    this.showComingSoon = false
  }

  connectedCallback () {
    super.connectedCallback()
  }

  attributeChangedCallback (name, oldValue, newValue) {
    if (name === 'product-title') {
      this.productName = newValue
      this.handleAriaLabel()
    }

    if (name === 'variant-id') {
      this.variantId = newValue

      this.querySelector('form').setAttribute('variant-id', this.variantId)
    }
  }

  setupListeners () {
    super.setupListeners()

    document
      .querySelectorAll(`[data-bis-modal-external-el="trigger"]`)
      .forEach(trigger => {
        this.listeners.add(trigger, `click`, this.handleTrigger.bind(this))
      })

    this.listeners.add(
      this.els.close.element,
      `click`,
      this.handleClose.bind(this),
    )

    this.listeners.add(this, `click`, this.handleOverlayClose.bind(this))
    this.addEventListener('backInStockSubscribed', this.handleClose.bind(this))

    window.BAO.eventBus.addEventListener(
      window.BAO.EVENTS.AFTER_PAGINATION_CHANGE,
      this.handleReAttachTriggers.bind(this),
    )

    window.BAO.eventBus.addEventListener(
      window.BAO.EVENTS.SEARCH.RENDERED,
      this.handleReAttachTriggers.bind(this),
    )
  }

  handleReAttachTriggers () {
    document
      .querySelectorAll(`[data-bis-modal-external-el="trigger"]`)
      .forEach(trigger => {
        this.listeners.add(trigger, `click`, this.handleTrigger.bind(this))
      })
  }

  async handleTrigger (event) {
    event.preventDefault()
    this.setAttribute('variant-id', event.target.dataset.variantId)
    this.setAttribute('product-title', event.target.dataset.productTitle)

    if (event.target.hasAttribute('data-is-coming-soon')) {
      this.showComingSoon = true
      this.showComingSoonView()
    } else {
      this.showComingSoon = false
      this.resetView()
    }

    this.handleOpen()
  }

  handleOverlayClose (event) {
    if (event.target === this) {
      this.handleClose()
    }
  }

  handleClose () {
    this.close()
    document.body.style.overflow = 'visible'
  }

  handleOpen () {
    this.showModal()
    document.body.style.overflow = 'hidden'
  }

  handleAriaLabel () {
    this.setAttribute(
      'aria-label',
      `Back in stock notification for ${this.productName}`,
    )
  }

  showComingSoonView () {
    this.els.heading.element.textContent = this.els.heading.element.dataset.comingSoonHeading

    this.els.submit.element
      .querySelector('[data-view="bis"]')
      .setAttribute('hidden', true)
    this.els.submit.element
      .querySelector('[data-view="coming-soon"]')
      .removeAttribute('hidden')
  }

  resetView () {
    this.els.heading.element.textContent = this.els.heading.element.dataset.bisHeading

    this.els.submit.element
      .querySelector('[data-view="coming-soon"]')
      .setAttribute('hidden', true)
    this.els.submit.element
      .querySelector('[data-view="bis"]')
      .removeAttribute('hidden')
  }
}

if (!customElements.get('bis-modal')) {
  customElements.define('bis-modal', BISModal, {
    extends: 'dialog',
  })
}
